module.exports = __webpack_public_path__ + "static/media/regions.807e490c.svg";